import { jsx as e } from "react/jsx-runtime";
import { useMemo as a } from "react";
import { classes as m } from "../../utils/styles.js";
import { useTranslation as f } from "../../hooks/useTranslation.js";
import "../Context/index.js";
import "../IconButton/index.js";
import "../../pagination-BeOG0tbT.js";
import "../ProductTable/TableRowGroup.js";
import r from "./nutritionalattributehighlights.module.js";
import { AttributeHighlight as h } from "./shared.js";
import "../../types/apiSchema.js";
import "../../types/localizationSchema.js";
const E = ({
  packagingMarkings: i,
  containerClassName: n,
  isHidden: p
}) => {
  const { tryTranslate: o } = f(), l = a(() => {
    if (!i)
      return null;
    const s = i.split("; ");
    if (s.length > 0)
      return s.slice(0, 3).map((t, c) => /* @__PURE__ */ e(
        h,
        {
          name: (
            // use icon with text label included for LUOMU here
            t === "EU_ORGANIC_FARMING" ? `${t}_LABEL` : t
          ),
          label: o(t) || t,
          hideLabel: !0
        },
        "marking" + c
      ));
  }, [i, o]);
  return l ? /* @__PURE__ */ e("div", { className: m([r.certWrapper, n ?? ""]), children: /* @__PURE__ */ e(
    "div",
    {
      className: m([
        r.certOnlyContainer,
        ...p ? [r.hidden] : []
      ]),
      children: /* @__PURE__ */ e("div", { className: r.elements, children: l })
    }
  ) }) : null;
};
export {
  E as CertificateIcons
};
